import { request, requestToken, requestTokenImage } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/share-link`;

class ShareLinkServices {
  async generate(payload = {}) {
    return requestToken.post(`${API_ROUTE}/generate`, payload);
  }

  async getShareCandidates() {
    return requestToken.get(`${API_ROUTE}/share-candidates`);
  }

  async getMyLinks() {
    return requestToken.get(`${API_ROUTE}/my-links`);
  }

  async getAllLinks() {
    return requestToken.get(`${API_ROUTE}/all`);
  }

  async deactivate(id) {
    return requestToken.post(`${API_ROUTE}/deactivate`, { id });
  }

  async recordCopy(id) {
    return requestToken.post(`${API_ROUTE}/record-copy`, { id });
  }

  async resolve(token, uid) {
    const qs = uid ? `?uid=${encodeURIComponent(uid)}` : "";
    return request.get(`${API_ROUTE}/resolve/${token}${qs}`);
  }

  async getApkInfo() {
    return request.get(`${API_ROUTE}/apk-info`);
  }

  async uploadApk(file, version) {
    const form = new FormData();
    form.append("apk", file);
    if (version) form.append("version", version);
    return requestTokenImage.post(`${API_ROUTE}/apk-upload`, form);
  }
}

export default ShareLinkServices;
